export const MW_CONTENT = {
  hero: {
    kicker: 'Para oficinas mecânicas e auto centers',
    title: 'Carro na oficina, orçamento na cabeça e cliente ligando toda hora para saber se ficou pronto?',
    subtitle:
      'Organize a ordem de serviço, o estoque de peças e o orçamento aprovado pelo cliente em um único sistema — sem caderno, sem post-it, sem esquecimento.',
    cta: 'Quero organizar minha oficina',
    ctaMessage: 'Quero conhecer o sistema para oficina mecânica do 77Gestão',
    urgency: 'Enquanto a OS fica só na cabeça do mecânico, um carro entra e sai da oficina sem controle nenhum.',
  },

  statsStrip: [
    { number: '100%', label: 'das OS vinculadas ao veículo e ao cliente', icon: 'fa-solid fa-car' },
    { number: 'Zero', label: 'promessa de prazo sem saber se a peça existe', icon: 'fa-solid fa-triangle-exclamation' },
    { number: '1 clique', label: 'para faturar e emitir a NFS-e', icon: 'fa-solid fa-file-invoice' },
  ],

  pain: {
    title: 'Se a rotina da sua oficina é assim, o problema não é você — é a falta de sistema',
    intro:
      'Toda oficina mecânica esbarra nos mesmos gargalos quando o controle é feito no caderno, no WhatsApp ou de cabeça.',
    items: [
      { icon: 'fa-solid fa-note-sticky', text: 'Ordem de serviço anotada em papel ou caderno, que some ou fica ilegível.' },
      { icon: 'fa-solid fa-box-open', text: 'Peça em falta bem na hora do conserto, porque ninguém olhou o estoque antes de prometer o prazo.' },
      { icon: 'fa-solid fa-phone-volume', text: 'Cliente ligando toda hora perguntando se o carro já ficou pronto.' },
      { icon: 'fa-solid fa-handshake-angle', text: 'Orçamento passado de boca, que vira discussão na hora de fechar a conta.' },
      { icon: 'fa-solid fa-car-burst', text: 'Sem histórico do carro: a cada retorno, ninguém lembra o que já foi feito nele.' },
      { icon: 'fa-solid fa-file-circle-exclamation', text: 'Nota fiscal do serviço emitida por fora, correndo atrás no fim do mês.' },
    ],
  },

  midCta: {
    text: 'E se cada carro que entra na oficina tivesse orçamento aprovado, peça reservada e nota fiscal automática?',
    cta: 'Quero ver como funciona',
    ctaMessage: 'Quero ver uma demonstração do sistema para oficina mecânica do 77Gestão',
  },

  solution: {
    title: 'Sua oficina do mesmo jeito que você trabalha, só que sem perder informação',
    intro:
      'O 77Gestão organiza a rotina da oficina do orçamento até a nota fiscal, vinculando cada ordem de serviço ao veículo e ao cliente.',
    cards: [
      {
        icon: 'fa-solid fa-car-side',
        title: 'OS vinculada ao veículo',
        text: 'Cada ordem de serviço fica registrada no histórico do carro — você vê tudo que já foi feito nele, de qualquer atendimento anterior.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Orçamento em PDF aprovado pelo cliente',
        text: 'Monte o orçamento, envie em PDF e só inicie o serviço depois da aprovação. Acabou a discussão na entrega.',
      },
      {
        icon: 'fa-solid fa-warehouse',
        title: 'Estoque de peças sob controle',
        text: 'Saiba o que tem disponível antes de prometer prazo ao cliente — sem procurar a peça só depois que o carro já está no elevador.',
      },
      {
        icon: 'fa-solid fa-receipt',
        title: 'NFS-e automática ao faturar',
        text: 'Ao fechar a ordem de serviço, a nota fiscal de serviço é emitida automaticamente. Sem retrabalho no fim do mês.',
      },
      {
        icon: 'fa-solid fa-address-book',
        title: 'Cadastro completo de clientes e veículos',
        text: 'Histórico de atendimentos, documentos e dados de contato — tudo num só lugar, pronto quando o cliente ligar.',
      },
      {
        icon: 'fa-solid fa-building-columns',
        title: 'Financeiro integrado',
        text: 'Contas a pagar e a receber, DRE e centro de custo conectados com cada ordem de serviço faturada.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a oficina para de depender da memória do mecânico',
    intro:
      'Uma oficina que controlava tudo em caderno e no boca a boca vivia cliente ligando para saber status e discussão de orçamento na entrega do carro.',
    stats: [
      { number: '0', label: 'discussões de orçamento após aprovação em PDF' },
      { number: '100%', label: 'das OS com histórico do veículo disponível' },
      { number: 'Menos', label: 'ligações de cliente perguntando status' },
    ],
    paragraphs: [
      'Depois da implantação acompanhada, cada carro que entra na oficina passou a ter orçamento formal aprovado antes do início do serviço.',
      'O controle de estoque de peças passou a orientar o prazo prometido ao cliente — e a nota fiscal de serviço deixou de ser um problema de fim de mês.',
    ],
    highlight: 'Resultado: menos discussão, menos ligação de cliente e faturamento em dia.',
    cta: 'Quero esse controle na minha oficina',
    ctaMessage: 'Vi o resultado e quero entender como organizar a minha oficina com o 77Gestão',
  },

  benefits: {
    title: 'Os três pilares para a rotina da oficina',
    items: [
      {
        icon: 'fa-solid fa-car-side',
        title: 'Histórico',
        text: 'Cada veículo com o registro completo de tudo que já foi feito nele, disponível a qualquer atendimento.',
      },
      {
        icon: 'fa-solid fa-file-signature',
        title: 'Aprovação formal',
        text: 'Orçamento em PDF aprovado pelo cliente antes de começar o serviço — sem depender de conversa verbal.',
      },
      {
        icon: 'fa-solid fa-boxes-stacked',
        title: 'Peça disponível',
        text: 'Estoque sob controle para prometer prazo real, sem surpresa de peça em falta no meio do conserto.',
      },
    ],
  },

  differentials: {
    title: 'Por que oficinas escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema simples, do tamanho da sua oficina — de uma bancada a um auto center completo.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: alguém te ajuda a configurar, você não começa sozinho.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado, para tirar dúvida no dia a dia.' },
      { icon: 'fa-solid fa-link', text: 'OS, estoque, financeiro e nota fiscal integrados — um lançamento alimenta tudo.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Minha oficina é pequena, vale a pena?',
        answer:
          'Vale. O sistema se adapta ao tamanho da operação — funciona tanto para uma oficina de bairro com poucos elevadores quanto para um auto center com várias equipes.',
      },
      {
        question: 'Preciso mudar como controlo o estoque de peças?',
        answer:
          'Não precisa mudar sua forma de trabalhar. Você cadastra as peças e o sistema controla entrada, saída e saldo por depósito, mostrando o que está disponível antes de você prometer prazo.',
      },
      {
        question: 'O sistema emite a nota fiscal de serviço automaticamente?',
        answer:
          'Sim. Ao faturar a ordem de serviço, a NFS-e é emitida automaticamente, sem precisar lançar por fora em outro sistema.',
      },
      {
        question: 'E se o cliente reclamar do orçamento depois?',
        answer:
          'Isso deixa de acontecer. O orçamento em PDF é aprovado pelo cliente antes do início do serviço — fica registrado o que foi combinado, evitando discussão na entrega do carro.',
      },
      {
        question: 'Dá para ver o histórico de um carro que já passou pela oficina antes?',
        answer:
          'Sim. Cada veículo fica vinculado ao cliente com o histórico completo de ordens de serviço anteriores, facilitando o diagnóstico e o atendimento.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de rodar atrás do orçamento perdido e da peça que faltou',
    subtitle:
      'Agende sua demonstração e veja, na prática, como organizar a ordem de serviço, o estoque de peças e a nota fiscal da sua oficina.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para oficina mecânica do 77Gestão',
  },

  seo: {
    title: 'Sistema para Oficina Mecânica — Ordem de Serviço e NFS-e | 77Gestão',
    description:
      'Sistema para oficina mecânica e auto center: ordem de serviço vinculada ao veículo, orçamento em PDF aprovado pelo cliente, controle de estoque de peças e NFS-e automática. Agende uma demonstração.',
  },
};
